// extracted by mini-css-extract-plugin
export default {"primary_btn":"Button_primary_btn__MqDM0","secondary_btn":"Button_secondary_btn__v9X9V"};